define('app/views/gift_button_view',['app/setup'], function(takhfifan) {

  takhfifan.giftButtonView = Backbone.View.extend({

    events: {
      'click': 'submit'
    },

    initialize: function(options) {
      this.productId = options.productId;
      var _this=this;
      takhfifan.eventHub.on('timeover:' + this.productId, function() {
        _this.disable();
      }, this);
      takhfifan.eventHub.on('buyButton:soldOut', function() {
        _this.disable();
      }, this);
      takhfifan.eventHub.on('giftButton:enable', function() {
        _this.setAsActive();
        _this.enable();
      }, this);
      takhfifan.eventHub.on('cartinfo:' + this.productId, function(){
        this.setAsActive();
      }, this);
    },

    submit: function(event) {
      event.preventDefault();
      var checkBeforeSubmit = false;
      this.setAsLoading();
      this.disable();
      if(this.$el.hasClass('tkh-configurable-gift-btn')) {
        checkBeforeSubmit = true;
      }
      takhfifan.eventHub.trigger('giftmessage:enableGift', {giftEnableUrl:this.$el.attr('data-giftaddress')
        ,productToAdd:this.productId,objectToPass:this, checkBeforeSubmit: checkBeforeSubmit});
      return false;
    },

    setAsLoading: function() {
      this.$el.addClass('loading');
      this.$el.empty().append('<div class="btn-text"><span class="spinner"></span></div>');
    },

    setAsActive: function() {
      this.$el.removeClass('loading');
      this.$el.empty().append('<span class="icon-gift"></span><span class="text">هدیه بدهید</span>');
    },

    disable: function() {
      this.undelegateEvents();
      this.$el.attr('disabled', true);
    },

    enable: function() {
      this.delegateEvents();
      this.$el.attr('disabled', false);
    }

  });

});

